import { render } from "./IssuesPage.vue?vue&type=template&id=4ceeca96&scoped=true"
import script from "./IssuesPage.vue?vue&type=script&lang=js"
export * from "./IssuesPage.vue?vue&type=script&lang=js"

import "./IssuesPage.vue?vue&type=style&index=0&id=4ceeca96&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceeca96"]])

export default __exports__